import { render, staticRenderFns } from "./CcicPhotoForm.vue?vue&type=template&id=047dd026&scoped=true"
import script from "./CcicPhotoForm.vue?vue&type=script&lang=js"
export * from "./CcicPhotoForm.vue?vue&type=script&lang=js"
import style0 from "./CcicPhotoForm.vue?vue&type=style&index=0&id=047dd026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047dd026",
  null
  
)

export default component.exports